import { stringify, type ParsedUrlQuery } from 'querystring';
import { safeFormatClientDate } from 'shared/util/datetime-fns';
import { queryParamToString } from 'shared/util/queryParamConverters';
import type { Filters, HotelOffer, PaymentType, RoomWithPeople } from '@/interfaces';
import type { BookingState } from '@/interfaces/bookingPage';
import {
    queryParamToDate,
    queryParamToInteger,
    queryParamToRooms,
    removeEmptyValues,
    roomsToQuery,
    roomsToQueryParams,
} from './queryParamConverters';

export const offerToBookingPageQueryParams = (offer: HotelOffer, rooms: readonly RoomWithPeople[]): string =>
    `${offer.hotelKey}/?checkInDate=${safeFormatClientDate(offer.checkInDate)}&checkOutDate=${safeFormatClientDate(
        offer.checkOutDate,
    )}&${roomsToQuery(rooms).join('&')}&bookingParams=${offer.bookingParams}`;

export const browserQueryParamsToBookingPageState = (query: ParsedUrlQuery): Partial<BookingState> =>
    removeEmptyValues({
        status: {
            errorCode: queryParamToInteger(query.errorCode),
        },
    });

export const browserQueryParamsToBookingFilters = (query: ParsedUrlQuery): Partial<Filters> =>
    removeEmptyValues({
        hotel: queryParamToString(query.hotel),
        checkInDate: queryParamToDate(query.checkInDate),
        checkOutDate: queryParamToDate(query.checkOutDate),
        rooms: queryParamToRooms(query.rooms),
    });

export const filtersToBookingPageBrowserQueryParams = (filters: Filters, bookingParams: string): string =>
    stringify(
        removeEmptyValues({
            hotel: filters.hotel,
            checkInDate: safeFormatClientDate(filters.checkInDate, undefined),
            checkOutDate: safeFormatClientDate(filters.checkOutDate, undefined),
            rooms: roomsToQueryParams(filters.rooms),
            bookingParams,
        }),
    );

export const parsePaymentType = (type: string): PaymentType => {
    if (/none/i.test(type)) {
        return 'none';
    }
    if (/netaxept/i.test(type)) {
        return 'netAxept';
    }
    if (/partial/i.test(type)) {
        return 'partial';
    }
    return null;
};
